import { Component } from '@angular/core';
import {MarkdownPipe} from "../../core/pipes/markdown.pipe";
import { HttpClient } from "@angular/common/http";
import {AsyncPipe} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-imprint',
  standalone: true,
  imports: [
    MarkdownPipe,
  ],
  templateUrl: './imprint.component.html',
  styleUrl: './imprint.component.scss'
})
export class ImprintComponent {

  public imprint: string = '';

  constructor(private http: HttpClient, private translate: TranslateService) {
    this.http.get("/assets/imprint-"+translate.currentLang+".md",  {responseType: "text"}).subscribe((data) => {
      this.imprint = data;
    }, (() => {
      this.http.get("/assets/imprint-de.md",  {responseType: "text"}).subscribe((data) => {
        this.imprint = data;
      });
    }));

  }
}
